import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import RouteDetails from './RouteDetails';
import { useRoutes, useToasts } from '../../hooks';
import { reorder } from '../../utils/dragDrop';

const RouteDetailsWrapper = ({
  currentRoute, handleOpenDeleteModal,
}) => {
  const [stopsArray, setStopsArray] = useState([]);
  const [isDragDisabled, setIsDragDisabled] = useState(false);

  const {
    date,
    stops,
    totalDistance,
    totalTime,

  } = currentRoute;

  useEffect(() => {
    setStopsArray(stops);
  }, [stops]);

  const {
    reorderStops, vamosMarkersRef,
  } = useRoutes();

  // Hook Toast
  // using existing Toast hook wrote on Bootstrap
  const { showToast } = useToasts();

  const handleStopClick = (stop) => {
    // Get the site marker reference from RoutesContext and execute the onClick function
    if (vamosMarkersRef && vamosMarkersRef.current[stop.site_id]) {
      vamosMarkersRef.current[stop.site_id].props.onClick();
    }
  };

  const onDragEnd = (result) => {
    // Disable the dragging until response is coming
    setIsDragDisabled(true);
    // if item dropped outside the droppable area
    if (!result.destination) {
      setIsDragDisabled(false);
      return;
    }
    // if item is dropped in same position
    if (result.destination.index === result.source.index) {
      setIsDragDisabled(false);
      return;
    }
    // find dragged routeStop
    const routeStop = stops.find(
      (stop) => stop.id === parseInt(result.draggableId, 10),
    );
    // get reordered items with new position we use -1 bc our positions start with 1 but index of array start with 0 and we need to send it to send indexes in reorder function
    const reorderedItems = reorder(
      stopsArray,
      result.source.index - 1,
      result.destination.index - 1,
    );

    const storedItems = stopsArray;
    // set reordered items to state
    setStopsArray(reorderedItems);
    // make an api call to update server with new position
    reorderStops(routeStop.id, result.destination.index)

      .catch((error) => {
        // set items back to previous state if there is problem with updating database
        setStopsArray(storedItems);
        // dispatch error to toast message
        showToast({ message: error.message, type: 'error' });
      })
      .finally(() => {
        // enable the dragging after response came either fulfilled or rejected
        setIsDragDisabled(false);
      });
  };

  return (
    <div>
      <RouteDetails routeDate={date} sitesArray={stopsArray} handleSiteClick={handleStopClick} handleRemoveStop={handleOpenDeleteModal} onDragEnd={onDragEnd} totalDistance={totalDistance} totalTime={totalTime} isDragDisabled={isDragDisabled} />
    </div>
  );
};

export default RouteDetailsWrapper;

RouteDetailsWrapper.propTypes = {
  currentRoute: PropTypes.object.isRequired,
  handleOpenDeleteModal: PropTypes.func.isRequired,
};

